import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './index.css';
import appstoreImage from './assets/AppStore.png';
import googlePlayImage from './assets/GooglePlay.png';

const thisYear = new Date().getFullYear();
const textCopyright = `© ${thisYear} Supersoccer TV, Inc. All rights reserved.`;
const imagesDownload = [
  {
    name: 'Google play',
    image_url: googlePlayImage,
    direct_click:
      'https://play.google.com/store/apps/details?id=air.com.arm_enterprises.supersoccer.england2014'
  },
  {
    name: 'Play store',
    image_url: appstoreImage,
    direct_click:
      'https://itunes.apple.com/id/app/supersoccer-tv/id902290991?mt=8'
  }
];

const Render = () => (
  <div className={s['elastic']}>
    <div className={s['elastic__container']}>
      <div className={s['elastic__footer-text']}>
        <p>{textCopyright}</p>
      </div>
      {/* <div className={s['elastic__footer-download']}>
        {imagesDownload.map((download, key) => (
          <span key={key}>
            <a href={download.direct_click}>
              <img
                src={download.image_url}
                alt={`Download application on ${download.name}`}
                height="30"
              />
            </a>
          </span>
        ))}
      </div> */}
    </div>
  </div>
);

export default withStyles(s)(Render);
